import { createSlice } from '@reduxjs/toolkit'
import { setNestedKey } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { TYPE_SORT } from '../../../constant'
import { handleSelectAllIdInTable } from '../../../helper'
import { TYPE_SORT_TABLE_DETAIL } from '../constant'
import {
  convertDataAddCompanyApi,
  convertDataReduxTableAddCompany,
  convertDataTableAddCompany,
  convertDataTableDetailPortfolio,
  getDataSizeTable,
  getListIdTableDetailPortfolio,
} from '../helper'
import {
  getAllIdCompanyInPortfolio,
  getHeaderSavedPortfolioDetail,
  getSearchCompanyInPortfolioDetails,
  postImportExcel,
} from './thunk'

const initialState = {
  ids: [],
  data: {},
  selectCheckBox: {
    listIdsSelected: {},
    listIdAllByTerm: [],
  },
  dataHeader: { numberOfCompany: 0 },
  isLoading: {
    SavedPortfolioDetail: false,
    HeaderSavedPortfolioDetail: false,
    typeAlertDetail: false,
    getAllId: false,
    importCompany: false,
  },
  typeAlertDetail: {},
  filter: {
    page: 1,
    pageSize: 20,
    totalRecords: 0,
    sort: TYPE_SORT_TABLE_DETAIL.DELIVERY_DATE,
    sortDirection: TYPE_SORT.DESCENDING,
  },
  textSearch: '',
  isSelectAll: false,
  addNewCompany: {
    listCompanyImport: [],
    idsTableAddCompany: [],
    dataTableAddCompany: {},
    invalidsTaxCode: [],
    duplicateTaxCodes: [],
  },
  isRedirect404: false,
}

const slice = createSlice({
  name: 'library/savedPortfolios/portfolioDetails',
  initialState,
  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    clearStoreAddNewCompany: (state) => {
      state.addNewCompany = initialState.addNewCompany
    },
    changeTypeAlertDetail: (state, action) => {
      state.typeAlertDetail = action.payload
    },
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
    changeListCompanyImport: (state, action) => {
      state.addNewCompany.listCompanyImport = convertDataTableAddCompany(
        state.addNewCompany.listCompanyImport,
        action.payload,
      )
      state.addNewCompany.idsTableAddCompany =
        state.addNewCompany.listCompanyImport.map((item) => item.id)
      state.addNewCompany.dataTableAddCompany = convertDataReduxTableAddCompany(
        convertDataTableAddCompany(
          state.addNewCompany.listCompanyImport,
          action.payload,
        ),
        state.addNewCompany.listCompanyImport.map((item) => item.id),
      )
    },
    removeCompanyImport: (state, action) => {
      state.addNewCompany.listCompanyImport =
        state.addNewCompany.listCompanyImport.filter(
          (item) => item.id !== action.payload,
        )
      state.addNewCompany.idsTableAddCompany =
        state.addNewCompany.idsTableAddCompany.filter(
          (item) => item !== action.payload,
        )
    },
    clearAllCompany: (state, action) => {
      state.addNewCompany.listCompanyImport = []
      state.addNewCompany.idsTableAddCompany = []
    },
    changeDataInCell: (state, action) => {
      const { rowId, colId, value } = action.payload
      state.data[rowId][colId] = value
    },
    changeTextSearch: (state, action) => {
      state.textSearch = action.payload
    },
    changeCheckboxTable: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state.selectCheckBox, path, data)
    },
    selectAllIdInTable: (state, action) => {
      state.selectCheckBox.listIdsSelected = handleSelectAllIdInTable(
        state.selectCheckBox.listIdsSelected,
        state.ids,
        action.payload,
      )
    },
    selectAllIdByTerm: (state, action) => {
      state.selectCheckBox.listIdsSelected = handleSelectAllIdInTable(
        state.selectCheckBox.listIdsSelected,
        state.selectCheckBox.listIdAllByTerm,
        action.payload,
      )
    },
    unSelectAllCheckbox: (state) => {
      state.selectCheckBox.listIdsSelected = {}
    },
    removeIdInListIdAll: (state, action) => {
      state.selectCheckBox.listIdAllByTerm =
        state.selectCheckBox.listIdAllByTerm.filter(
          (item) => !action.payload.includes(item),
        )
    },
  },

  extraReducers: (builder) => {
    //get data Header SavedPortfolio Detail
    builder.addCase(getHeaderSavedPortfolioDetail.pending, (state, action) => {
      state.isLoading.HeaderSavedPortfolioDetail = true
    })
    builder.addCase(
      getHeaderSavedPortfolioDetail.fulfilled,
      (state, action) => {
        state.dataHeader = action.payload
        state.isLoading.HeaderSavedPortfolioDetail = false
      },
    )
    builder.addCase(getHeaderSavedPortfolioDetail.rejected, (state, action) => {
      state.isLoading.HeaderSavedPortfolioDetail = false
    })

    //get data search company
    builder.addCase(
      getSearchCompanyInPortfolioDetails.pending,
      (state, action) => {
        state.isLoading.SavedPortfolioDetail = true
      },
    )
    builder.addCase(
      getSearchCompanyInPortfolioDetails.fulfilled,
      (state, action) => {
        state.ids = getListIdTableDetailPortfolio(action.payload.data)
        state.data = convertDataTableDetailPortfolio(action.payload.data)
        state.filter = { ...state.filter, ...getDataSizeTable(action.payload) }
        state.isLoading.SavedPortfolioDetail = false
        state.isRedirect404 = false
      },
    )
    builder.addCase(
      getSearchCompanyInPortfolioDetails.rejected,
      (state, action) => {
        state.isLoading.SavedPortfolioDetail = false
        state.ids = []
        state.isRedirect404 = true
      },
    )

    //import excel for data company postImportExcel
    builder.addCase(postImportExcel.pending, (state) => {
      state.isLoading.importCompany = true
      state.addNewCompany.invalidsTaxCode = []
      state.addNewCompany.duplicateTaxCodes = []
    })
    builder.addCase(postImportExcel.fulfilled, (state, action) => {
      const data = convertDataAddCompanyApi(action.payload.addComItems)
      state.addNewCompany.listCompanyImport = convertDataTableAddCompany(
        state.addNewCompany.listCompanyImport,
        data,
        true,
      )
      state.addNewCompany.idsTableAddCompany =
        state.addNewCompany.listCompanyImport.map((item) => item.id)
      state.addNewCompany.dataTableAddCompany = convertDataReduxTableAddCompany(
        convertDataTableAddCompany(state.addNewCompany.listCompanyImport, data),
        state.addNewCompany.listCompanyImport.map((item) => item.id),
      )
      state.addNewCompany.invalidsTaxCode = action.payload?.invalidTaxCodes
      state.addNewCompany.duplicateTaxCodes = action.payload?.duplicateTaxCodes
      state.isLoading.importCompany = false
    })
    builder.addCase(postImportExcel.rejected, (state, action) => {
      state.addNewCompany.invalidsTaxCode = []
      state.addNewCompany.duplicateTaxCodes = []
      state.isLoading.importCompany = true
    })

    //getAllIdCompanyInPortfolio
    builder.addCase(getAllIdCompanyInPortfolio.pending, (state, action) => {
      state.isLoading.getAllId = true
    })
    builder.addCase(getAllIdCompanyInPortfolio.fulfilled, (state, action) => {
      state.selectCheckBox.listIdAllByTerm = action.payload
      state.isLoading.getAllId = false
    })
    builder.addCase(getAllIdCompanyInPortfolio.rejected, (state, action) => {
      state.isLoading.getAllId = action.payload.loading
    })
  },
})

//getSavedPortfolioDetail
export const selectIdsTablePortfolioDetail = (state) => state[slice.name].ids
export const selectDataTablePortfolioDetail = (rowId, colId) => (state) => {
  return state[slice.name].data[rowId][colId]
}
export const selectDataSelectedTablePortfolioDetail = (state) =>
  state[slice.name].data
export const selectLoadingTablePortfolioDetail = (state) =>
  state[slice.name].isLoading.SavedPortfolioDetail
//checkbox Table
export const selectDataCheckBox = (type) => (state) =>
  state[slice.name].selectCheckBox[type]
export const selectCheckboxDetail =
  (attr = [], callback) =>
  (state) => {
    const data = attr.reduce(
      (result, key) => result[key],
      state[slice.name].selectCheckBox,
    )
    return callback ? callback(data) : data
  }
//Header SavedPortfolio Detail
export const selectDataHeaderPortfolioDetail = (state) =>
  state[slice.name].dataHeader
export const selectLoadingHeaderPortfolioDetail = (state) =>
  state[slice.name].isLoading.HeaderSavedPortfolioDetail
//typeAlert
export const selectTypeAlertDetail = (state) =>
  state[slice.name].typeAlertDetail
export const selectLoadingTypeAlertDetail = (state) =>
  state[slice.name].isLoading.typeAlertDetail
//data filter
export const selectDataFilter = (state) => state[slice.name].filter
//textSearch
export const selectTextSearch = (state) => state[slice.name].textSearch
//list ListCompanyImport
export const selectListCompanyImport = (state) =>
  state[slice.name].addNewCompany.listCompanyImport

//table AddCompany
export const selectIdsTableAddCompany = (state) =>
  state[slice.name].addNewCompany.idsTableAddCompany
export const selectDataTableAddCompany = (rowId, colId) => (state) => {
  return state[slice.name].addNewCompany.dataTableAddCompany[rowId][colId]
}
export const selectInvalidAddCompany = (state) =>
  state[slice.name].addNewCompany.invalidsTaxCode
export const selectInvalidDuplicateAddCompany = (state) =>
  state[slice.name].addNewCompany.duplicateTaxCodes
export const selectLoadingImportCompany = (state) =>
  state[slice.name].isLoading.importCompany
export const selectIsRedirect404 = (state) => state[slice.name].isRedirect404

export const {
  resetStore,
  changeTypeAlertDetail,
  changeFilter,
  changeListCompanyImport,
  removeCompanyImport,
  clearAllCompany,
  changeDataInCell,
  changeTextSearch,
  clearCheckBoxDetailsPortfolio,
  clearStoreAddNewCompany,
  changeCheckboxTable,
  selectAllIdInTable,
  selectAllIdByTerm,
  unSelectAllCheckbox,
  removeIdInListIdAll,
} = slice.actions

register(slice.name, slice.reducer)
